import React from 'react'
import RelativeDatePicker from '../../../pickers/relativeDatePicker'
import {
    DateRange,
    useGetTherapistPerformanceQuery,
} from '../../../../generated/graphql'
import Grid from '@mui/material/Grid'
import { Paper, Typography } from '@mui/material'
import CustomDataGrid from '../../../customDataGrid'

const TherapistPerformance = () => {
    const [dateRange, setDateRange] = React.useState<DateRange>()

    const onDateSelected = React.useCallback((dateRange: DateRange) => {
        setDateRange(dateRange)
    }, [])

    const { data, loading } = useGetTherapistPerformanceQuery({
        variables: {
            data: {
                from: dateRange?.from,
                to: dateRange?.to,
            },
        },
    })

    const columns = React.useMemo(
        () => [
            { field: 'id', headerName: 'Therapist' },
            { field: 'name', headerName: 'Therapist', flex: 4 },
            { field: 'sessions', headerName: 'Sessions', flex: 2 },
            {
                field: 'totalInvoiced',
                headerName: 'Invoiced',
                flex: 2,
            },
            { field: 'totalTherapist', headerName: 'Therapist', flex: 2 },
            { field: 'totalIrpf', headerName: 'Irpf', flex: 2 },
            { field: 'totalOhana', headerName: 'Ohana', flex: 2 },
        ],
        []
    )

    const rows = React.useMemo(() => {
        return (
            data?.therapistPerformance?.map((t) => ({
                ...t,
                id: t.therapistName,
                name: t.therapistName,
                sessions: t.sessions,
                totalInvoiced: `${(t.totalInvoiced || 0).toFixed(2)}€`,
                totalOhana: `${(t.totalOhana || 0).toFixed(2)}€`,
                totalIrpf: `${(t.therapistIrpf || 0).toFixed(2)}€ (${
                    t.therapistIrpf
                }%)`,
                totalTherapist: `${(t.totalTherapist || 0).toFixed(2)}€`,
            })) || []
        )
    }, [data?.therapistPerformance])

    return (
        <Paper sx={{ padding: 2 }}>
            <Grid
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'space-between'}
                gap={1}
            >
                <Grid
                    display={'flex'}
                    flexDirection={'row'}
                    gap={2}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                >
                    <Typography variant={'h5'} sx={{ width: 400 }}>
                        Therapist performance
                    </Typography>
                    <RelativeDatePicker onChange={onDateSelected} />
                </Grid>
                <CustomDataGrid
                    columns={columns}
                    rows={rows}
                    loading={loading}
                />
            </Grid>
        </Paper>
    )
}

export default React.memo(TherapistPerformance)
